import React, { useEffect, useState } from 'react';
import { FaEye, FaDownload } from 'react-icons/fa';
import '../../styles/user/totalCandidatesPage.css';
import {
  fetchTotalCandidates,
  fetchCandidateInfo,
  downloadReport 
} from '../../services/user/api';
import {  Search } from 'lucide-react';


const TotalCandidatesPage = ({onViewFinalReport,onViewReportTwo }) => {
  const [candidates, setCandidates] = useState([]);
  const [fetchError, setFetchError] = useState(null);
const [currentPage, setCurrentPage] = useState(0); 
  const [totalElements, setTotalElements] = useState(0);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [selectedCandidateData, setSelectedCandidateData] = useState(null);
  const [showReportModal, setShowReportModal] = useState(false);
  const [entriesPerPage, setEntriesPerPage] = useState(10);

  const startIndex = (currentPage - 1) * entriesPerPage;
  const totalPages = Math.ceil(totalElements / entriesPerPage);

useEffect(() => {
  loadCandidates(currentPage); 
}, [currentPage, entriesPerPage]);



  const loadCandidates = async (page) => {
    try {
      setLoading(true);
      const response = await fetchTotalCandidates(page, entriesPerPage);
      const data = response.data.data;

      setCandidates(data?.content || []);
      setTotalElements(data?.totalElements || 0);
      setFetchError(null);
    } catch (error) {
      console.error('API Error:', error);
      setFetchError('An error occurred while fetching data.');
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadReport = async (candidateId) => {
  try {
    const response = await downloadReport(candidateId);
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${candidateId}_FinalReport.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Failed to download report", error);
  }
};
 const handleViewDetails = async (candidateId) => {
    try {
      const response = await fetchCandidateInfo(candidateId);
      if (response?.data?.status) {
        setSelectedCandidateData(response.data.data);
        setShowReportModal(true);
      } else {
        alert(response?.data?.message || 'Failed to fetch candidate info');
      }
    } catch (error) {
      alert('Error fetching candidate details');
    }
  };


  const filteredCandidates = candidates.filter((c) =>
    c.fullname?.toLowerCase().includes(search.toLowerCase()) ||
    c.email?.toLowerCase().includes(search.toLowerCase()) ||
    c.candidateid?.toLowerCase().includes(search.toLowerCase())
  );

  return (
   <>
          <p className="client-header">Total Candidates</p>

    <div className="client-wrapper">

      <div className="clinet-table-controls">
        <div className="entries-select">
          Show{' '}
         <select
  value={entriesPerPage}
  onChange={(e) => {
    setEntriesPerPage(Number(e.target.value));
    setCurrentPage(0);
    setCurrentPage(0);
  }}
>
  <option value="10">10</option>
  <option value="25">25</option>
  <option value="50">50</option>
</select>
{' '}
          entries
        </div>
      <div className="client-search-box">
        {/* <label htmlFor="client-search-input">Search:</label> */}
        <div className="client-search-input-wrapper">
          <input
            id="client-search-input"
            type="text"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(0);
            }}
            placeholder="Search by name"
          />
          <Search className="client-search-icon" size={18} />
        </div>
      </div>
      </div>

      <div className="clinet-table-container">
        {loading ? (
          <div className="loading">Loading...</div>
        ) : fetchError ? (
          <div className="error-message">{fetchError}</div>
        ) : (
          <table className="candidates-clinet-table">
            <thead>
              <tr>
                <th>Candidate ID</th>
                <th>Name</th>
                <th>Email</th>
                <th>Mobile Number</th>
                <th>DOB</th>
                <th>Case Initiated Date</th>
                <th>Case Initiated Time</th>
                <th>BGC Start Date</th>
                <th>BGC Complete Date</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredCandidates.length > 0 ? (
                filteredCandidates.map((candidate) => (
                  <tr key={candidate.candidateid}>
                    <td>{candidate.candidateid}</td>
                    <td>{candidate.fullname}</td>
                    <td>{candidate.email}</td>
                    <td>{candidate.mobileNumber}</td>
                    <td>{candidate.dateOfBirth}</td>
                    <td>{candidate.caseInitiatedDateOnlyAsString || '---'}</td>
                    <td>{candidate.caseInitiatedTimeOnly || '---'}</td>
                    <td>{candidate.bgcStartDateOnlyString || '---'}</td>
                    <td>{candidate.bgcCompletedDateOnlyString || '---'}</td>
                    <td>
                      <span className={`status-tag ${String(candidate.bgcStatus).toLowerCase()}`}>
                        {String(candidate.bgcStatus)}
                      </span>
                    </td>
                    <td>
                 <button
                     className={`icon-btn ${
                       candidate.bgcStatus === 'PENDING_SUBMISSION'
                         ?   'text-gray-400'
                          : 'text-indigo-600'
                            }`}
                           title="View Report"
                            onClick={() => onViewReportTwo(candidate.candidateid)}
                            disabled={candidate.bgcStatus === 'PENDING_SUBMISSION'}
                              >
                              <FaEye />
                        </button>

                  <button
                          className="icon-btn"
                          title={
                           candidate.bgcStatus === 'COMPLETED'
                           ? 'Download PDF'
                           : 'Available only after verification'
                              }
                          onClick={() => onViewFinalReport(candidate.candidateid)}
                          disabled={candidate.bgcStatus !== 'COMPLETED'}
                           >
                       <FaDownload
                         className={
                           candidate.bgcStatus === 'COMPLETED'
                                ? 'text-purple-600 hover:text-purple-800'
                                : 'text-gray-400'
                            }
                         />
                      </button>

                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="11" className="no-data">No matching candidates found.</td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>

      
{totalPages > 1 && (
  <div className="pagination">
    <div className="pagination-summary">
      Showing {currentPage * entriesPerPage + 1} to{' '}
      {Math.min((currentPage + 1) * entriesPerPage, totalElements)} of {totalElements} entries
    </div>
    <div className="pagination-buttons-user">
      {/* Previous Button */}
      <button
        className="page-btn"
        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 0))}
        disabled={currentPage === 0}
      >
        ←
      </button>

      {/* Current Page */}
      <button
        className="page-btn active"
        onClick={() => setCurrentPage(currentPage)}
      >
        {currentPage + 1}
      </button>

      {/* Next Page */}
      {currentPage + 1 < totalPages && (
        <button
          className="page-btn"
          onClick={() => setCurrentPage(currentPage + 1)}
        >
          {currentPage + 2}
        </button>
      )}

      {/* Next Arrow */}
      <button
        className="page-btn"
        onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages - 1))}
        disabled={currentPage === totalPages - 1}
      >
        →
      </button>
    </div>
  </div>
)}


      {/* Modal */}
      {showReportModal && selectedCandidateData && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="close-btn" onClick={() => setShowReportModal(false)}>×</button>
            <h2 className="modal-title">Candidate Full Report</h2>

            <h3>Personal Info</h3>
            <p><strong>Name:</strong> {selectedCandidateData.personalInfoResponse?.firstName} {selectedCandidateData.personalInfoResponse?.lastName}</p>
            <p><strong>Email:</strong> {selectedCandidateData.personalInfoResponse?.email}</p>
            <p><strong>Mobile:</strong> {selectedCandidateData.personalInfoResponse?.mobileNumber}</p>
            <p><strong>DOB:</strong> {selectedCandidateData.personalInfoResponse?.dateOfBirth}</p>
            <p><strong>Gender:</strong> {selectedCandidateData.personalInfoResponse?.gender}</p>
            <p><strong>Father's Name:</strong> {selectedCandidateData.personalInfoResponse?.fatherName}</p>
            <p><strong>Nationality:</strong> {selectedCandidateData.personalInfoResponse?.nationality}</p>
            <p><strong>Aadhaar Number:</strong> {selectedCandidateData.personalInfoResponse?.aadhaarCardNumber}</p>
            <p><strong>Personal Image:</strong> <a href={selectedCandidateData.personalInfoResponse?.personalImageFileName} target="_blank" rel="noreferrer">View</a></p>
            <p><strong>Aadhaar Proof:</strong> <a href={selectedCandidateData.personalInfoResponse?.aadhaarProofFileName} target="_blank" rel="noreferrer">View</a></p>

            <h3>Address Info</h3>
            <p><strong>Current:</strong> {selectedCandidateData.addressInfoResponse?.currentAddressLine1}, {selectedCandidateData.addressInfoResponse?.currentCity}</p>
            <p><strong>Proof:</strong> <a href={selectedCandidateData.addressInfoResponse?.currentAddressFile} target="_blank" rel="noreferrer">View</a></p>

            <p><strong>Permanent:</strong> {selectedCandidateData.addressInfoResponse?.permanentAddressLine1}, {selectedCandidateData.addressInfoResponse?.permanentCity}</p>
            <p><strong>Proof:</strong> <a href={selectedCandidateData.addressInfoResponse?.permanentAddressFile} target="_blank" rel="noreferrer">View</a></p>

            <h3>Education</h3>
            <ul>
              {selectedCandidateData.educationInfos?.map((edu, idx) => (
                <li key={idx}>
                  <p><strong>{edu.educationLevel}</strong> - {edu.instituteName} ({edu.enrolledYear} to {edu.passingYear})</p>
                  <a href={edu.certificateFileUrl} target="_blank" rel="noreferrer">View Certificate</a>
                </li>
              ))}
            </ul>

            <h3>Employment</h3>
            <ul>
              {selectedCandidateData.employmentInfos?.map((emp, idx) => (
                <li key={idx}>
                  <p><strong>Company:</strong> {emp.companyName} | <strong>Title:</strong> {emp.jobTitle}</p>
                  <p><strong>From:</strong> {emp.workingFrom} <strong>To:</strong> {emp.workingTo}</p>
                  {emp.offerLetterUrl && <a href={emp.offerLetterUrl} target="_blank" rel="noreferrer">View Offer Letter</a>}
                  {emp.salarySlipsUrl && emp.salarySlipsUrl.split(',').map((url, i) => (
                    <a key={i} href={url} target="_blank" rel="noreferrer">View Slip {i + 1}</a>
                  ))}
                  {emp.bankStatementUrl && <a href={emp.bankStatementUrl} target="_blank" rel="noreferrer">View Bank Statement</a>}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
    </>
  );
};

export default TotalCandidatesPage;
